<div class="card bg-base-100 border border-base-300 overflow-hidden">

  <!-- Header: title + subtitle + optional table-level controls -->
  @if (title || subtitle) {
    <div class="px-6 py-4 border-b border-base-300 flex items-start justify-between gap-4 flex-wrap">
      <div>
        @if (title) {
          <h2 class="text-lg font-semibold">{{ title }}</h2>
        }
        @if (subtitle) {
          <p class="text-sm text-base-content/60 mt-0.5">{{ subtitle }}</p>
        }
      </div>
      <!-- Slot for search / filter controls that belong inside the card.
           NOTE: "Add" actions belong on the page, not here. -->
      <div class="flex items-center gap-2">
        <ng-content select="[table-controls]"></ng-content>
      </div>
    </div>
  }

  <!-- Loading skeleton -->
  @if (loading) {
    <div class="p-4 space-y-3" aria-busy="true" aria-label="Loading…">
      @for (row of skeletonRowsArray; track row) {
        <div class="flex gap-3 animate-pulse">
          <div class="skeleton h-8 flex-1 rounded"></div>
          <div class="skeleton h-8 w-28 rounded"></div>
          <div class="skeleton h-8 w-20 rounded"></div>
        </div>
      }
    </div>
  }

  <!-- Empty state -->
  @if (!loading && empty) {
    @if (emptyStateTpl) {
      <div class="py-5">
      <ng-container *ngTemplateOutlet="emptyStateTpl" ></ng-container>
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center py-16 gap-3 text-base-content/40">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-12 w-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="1">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 10h18M3 14h18M10 3v18M14 3v18" />
        </svg>
        <p class="text-sm font-medium">{{ emptyMessage }}</p>
      </div>
    }
  }

  <!-- Table content (projected from parent) -->
  @if (!loading && !empty) {
    <div class="overflow-x-auto">
      <ng-content></ng-content>
    </div>
  }

</div>

